/**
 * Start of a speaker turn: `[Name]: ` or `[Name] (timestamp): `.
 * Must not match inline markers like `[inaudible]` (no `: ` after the bracket).
 */
const SPEAKER_TURN_START = /(?=\[[^\]]+\](?:\s+\([^)]+\))?\s*:\s)/;

class TranscriptFormatter {
  transcriptSplitter(transcript: string): string[] {
    const lines = transcript.split(SPEAKER_TURN_START);

    return lines.map(line => line.trim()).filter(line => line !== '');
  }
}

export const transcriptFormatter = new TranscriptFormatter();
